'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MenuListContext: function() {
        return MenuListContext;
    },
    MenuListProvider: function() {
        return MenuListProvider;
    },
    useMenuListContext_unstable: function() {
        return useMenuListContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactcontextselector = require("@fluentui/react-context-selector");
const MenuListContext = (0, _reactcontextselector.createContext)(undefined);
const menuListContextDefaultValue = {
    checkedValues: {},
    setFocusByFirstCharacter: ()=>null,
    toggleCheckbox: ()=>null,
    selectRadio: ()=>null,
    hasIcons: false,
    hasCheckmarks: false
};
const MenuListProvider = MenuListContext.Provider;
const useMenuListContext_unstable = (selector)=>(0, _reactcontextselector.useContextSelector)(MenuListContext, (ctx = menuListContextDefaultValue)=>selector(ctx));
